import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import { ErrorMessage, PdfMessage, SuccessMessage } from "src/constants/Constant";
import { AppDispatch } from 'src/store';

interface TopThreeData {
    BSUSNumber: string;
    partNumber: string;
    spImageUrl: string;
}

interface LatfivePartsProps {
    orderNumber: string;
    x_quote_date: string;
    y_quote_value: number;
}

interface MonthWiseQuote {
    y_total_quote_his: number;
    x_quote_month: number;
    x_quote_monthName: string;
}
interface TopFiveProps {
    sparePartNumber: string;
    BSUSNumber: string;
    quantitySum: number;
    monthNo: string;
    Year: string;
}
interface UserHisProps {
    firstName: string;
    lastName: string;
    email: string;
    total_quotes_generated: number;
}
interface UserHisErrorProps {
    location: string;
    msg: string;
    param: string;
    value: number;
}
interface QuoteHisProps {
    serialNumber: number;
    email: string;
    orderNumber: number;
    formatted_date: number;
    orderAmount: number;
    orderStatus: string;
    action: string;
}

interface QuoteHisErrorProps {
    locatin: string;
    msg: string;
    param: string;
    value: number;
}
interface ApiErrorMessage {
    status: boolean,
    message: string
}
interface RealtimeEntry {
    timestamp: string;
    count: number;
    activeUsers?: number;

}

interface MblApp {

    App: {
        isLoading: boolean;
        status: boolean;
        message: string;
        data: TopThreeData[];
        error: boolean;
    },
    LatFive: {
        isLoading: boolean;
        status: boolean;
        message: string;
        data: LatfivePartsProps[];
        error: boolean;
    },
    TopFive: {
        isLoading: boolean;
        status: boolean;
        message: string;
        data: TopFiveProps[];
        error: boolean;
    },
    MonthWise: {
        isLoading: boolean;
        status: boolean;
        message: string;
        data: MonthWiseQuote[];
        error: boolean;
    },
    UserHis: {
        isLoading: boolean;
        max: string | number;
        limit: any;
        currentPage: any;
        status: boolean;
        message: string;
        data: {
            count: string,
            rows: UserHisProps[]
        }
        data1: UserHisErrorProps[];
        error: boolean;
    },
    UserHisError: {
        isLoading: boolean;
        status: boolean;
        message: string;

        error: boolean;
    },
    search: {
        type: string,
        action: string,
        data: any
    },
    pagination: {
        isLoading: false,
        max: string | number;
        limit: any;
        currentPage: any;
        data: {
            count: string,
            rows: UserHisProps[]
        }
    }
    QuoteHis: {
        isLoading: boolean;
        max: string | number;
        limit: any;
        currentPage: any;
        status: boolean;
        message: string;
        data: {
            count: string;
            rows: QuoteHisProps[]
        }
        data1: QuoteHisErrorProps[];
        error: boolean;
    },
    QuoteHisError: {
        isLoading: boolean;
        status: boolean;
        message: string;
        error: boolean;
    },
    QuotePdf: {
        isLoading: boolean;
        status: boolean;
        message: string;
        data: any;
        error: any;
    },
    QuotePdfError: {
        isLoading: boolean;
        status: boolean;
        message: string;
        error: any;
    },
    pagination1: {
        isLoading: boolean;
        max: string | number;
        limit: any;
        currentPage: any;
        data: {
            count: string;
            rows: QuoteHisProps[]
        }
    },
    AlertMessageState: {
        show: boolean;
        type: string;
        message: string;
        showModal: boolean;
    },
    ErrorMessage: {
        data: ApiErrorMessage,
        error: boolean,
    },
    UserActivityState: {
        activityData: [],
        monthlyCounts: {},
        realtimeData: RealtimeEntry|null,
        loading: boolean,
        error: string | null,
    },

    EventState: {
        allEvents: {
            Search?: any[];
            MostViewedProduct?: any[];
            QrCode?: any[];
            QuoteDetails?: any[];
        };
        eventName: any[];
        loading: boolean;
        error: string | null;
    },




}
interface EventData {
    counts: number[];
    users: number;
    eventCount: number;
    value: number;
}
interface UserActivity {
    date: string;
    eventCount: number;
    totalUsers: number;
}


const initialState: MblApp = {
    EventState: {
        allEvents: {},
        eventName: null,
        loading: false,
        error: null
    },

    App: {
        isLoading: true,
        status: false,
        message: '',
        data: [],
        error: false
    },
    LatFive: {
        isLoading: true,
        status: false,
        message: '',
        data: [],
        error: false
    },
    TopFive: {
        isLoading: true,
        status: false,
        message: '',
        data: [],
        error: false
    },
    MonthWise: {
        isLoading: true,
        status: false,
        message: '',
        data: [],
        error: false
    },
    UserHis: {
        isLoading: true,
        max: 1,
        limit: 10,
        currentPage: 1,
        status: false,
        message: '',
        data: {
            count: '',
            rows: [],
        },
        data1: [],
        error: false
    },
    UserHisError: {
        isLoading: false,
        status: false,
        message: '',
        error: false
    },
    search: {
        type: '',
        action: '',
        data: null
    },
    ErrorMessage: {
        data: null,
        error: false
    },
    pagination: {
        isLoading: false,
        max: 1,
        limit: 10,
        currentPage: 1,
        data: {
            count: '',
            rows: [],
        },
    },
    AlertMessageState: null,
    QuoteHis: {
        isLoading: true,
        max: '',
        limit: undefined,
        currentPage: undefined,
        status: false,
        message: '',
        data: {
            count: '',
            rows: []
        },
        data1: [],
        error: false
    },
    QuoteHisError: {
        isLoading: false,
        status: false,
        message: '',
        error: false
    },
    QuotePdf: {
        isLoading: false,
        status: false,
        message: '',
        data: null,
        error: false
    },
    QuotePdfError: {
        isLoading: false,
        status: false,
        message: '',
        error: false
    },
    pagination1: {
        isLoading: false,
        max: '',
        limit: undefined,
        currentPage: undefined,
        data: {
            count: '',
            rows: []
        }
    },
    UserActivityState: {
        activityData: [],
        monthlyCounts: {},
        realtimeData: null,
        loading: false,
        error: null,
    }

};

const Slice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        TopthreePartsLoading(state) {
            state.App.isLoading = true;
        },
        TopthreeParts: (state, action) => {
            state.App = {
                ...state.App,
                isLoading: false,
                status: action.payload.status,
                data: action.payload.data,
                message: action.payload.message,
                error: false
            };
        },
        TopthreeError: (state, action) => {
            state.App = {
                ...state.App,
                isLoading: false,
                data: null,
                status: false,
                message: action.payload,
                error: true
            }
        },
        GetTopFiveLoading(state) {
            state.TopFive.isLoading = true;
        },
        GetTopFive: (state, action) => {
            state.TopFive = {
                ...state.TopFive,
                isLoading: false,
                status: action.payload.status,
                data: action.payload.data,
                message: action.payload.message,
                error: false
            }
        },
        GetTopFiveError: (state, action) => {
            state.TopFive = {
                ...state.TopFive,
                isLoading: false,
                data: null,
                status: false,
                message: action.payload,
                error: true
            }
        },
        LatFivePartsLoading(state) {
            state.LatFive.isLoading = true;
        },
        LatFiveParts: (state, action) => {
            state.LatFive = {
                ...state.LatFive,
                isLoading: false,
                status: action.payload.status,
                data: action.payload.data,
                message: action.payload.message,
                error: false
            };
        },
        LatFiveError: (state, action) => {
            state.LatFive = {
                ...state.LatFive,
                isLoading: false,
                data: null,
                status: false,
                message: action.payload,
                error: true
            }
        },

        MonthWiseLoading(state) {
            state.MonthWise.isLoading = true;
        },
        MonthWise: (state, action) => {
            state.MonthWise = {
                ...state.MonthWise,
                isLoading: false,
                status: action.payload.status,
                data: action.payload.data,
                message: action.payload.message,
                error: false
            };
        },
        MonthWiseError: (state, action) => {
            state.MonthWise = {
                ...state.MonthWise,
                isLoading: false,
                data: null,
                status: false,
                message: action.payload,
                error: true
            }
        },
        UserHisDataLoading(state) {
            state.UserHis.isLoading = true;
        },
        UserHisData: (state, action) => {
            state.UserHis = {
                ...state.UserHis,
                isLoading: false,
                status: action.payload.status,
                data: action.payload.data,
                message: action.payload.message,
                error: false
            };
        },
        SearchInfo: (state, action) => {
           
            state.search = {
                
                action: action.payload.action,
                type: action.payload.type,
                data: action.payload.data
            }
        },
        clearUserHisData(state) {
            state.UserHis.data = null
        },
        UserHisError: (state, action) => {
            state.UserHis = {
                ...state.UserHis,
                isLoading: false,
                data: null,
                data1: action.payload.data,
                status: action.payload.status,
                message: action.payload.message,
                error: true
            }
        },
        QuoteHisLoading(state) {
            state.QuoteHis.isLoading = true;
        },
        QuoteHisData: (state, action) => {
            state.QuoteHis = {
                ...state.QuoteHis,
                isLoading: false,
                status: action.payload.status,
                data: action.payload.data,
                message: action.payload.message,
                error: false
            };
        },
       
        clearQuoteHisData(state) {
            state.QuoteHis.data = null
        },
        QuoteHisError: (state, action) => {
            state.QuoteHis = {
                ...state.QuoteHis,
                isLoading: false,
                data: null,
                status: false,
                message: action.payload.message,
                error: true
            };
        },
        QuoteHisPdfLoading: (state) => {
            state.QuotePdf.isLoading = true;
        },
        QuoteHisPdfData: (state, action) => {
            state.QuotePdf = {
                ...state.QuotePdf,
                isLoading: false,
                status: true,
                data: action.payload.data,
                message: action.payload.message,
                error: false
            };
        },
        QuoteHisPdfError: (state, action) => {
            state.QuotePdf = {
                ...state.QuotePdf,
                isLoading: false,
                data: null,
                status: false,
                message: action.payload.message,
                error: true
            };
        },
        showAlertMessage(state, action) {
            state.AlertMessageState = {
                show: true,
                type: action.payload.type,
                message: action.payload.message,
                showModal: action.payload.showModal,
            };
        },
        ErrorMessage(state, action) {
            state.ErrorMessage = {
                data: action.payload,
                error: true
            }


        },
        clearAlertMessage(state) {
            state.AlertMessageState = {
                show: false,
                type: null,
                message: null,
                showModal: false,
            };
        },
       
        setError(state, action) {
            state.EventState.error = action.payload;
        },
       
        setEventByName(
            state,
            action: PayloadAction<{ eventName: string; data: EventData }>
        ) {
            state.EventState.allEvents[action.payload.eventName] = action.payload.data;
        },
        setAllEvents(state, action) {
            state.EventState.allEvents = action.payload;
        },
        setLoading(state, action) {
            state.EventState.loading = action.payload;
        },
       
        setLoader: (state, action) => {
            state.UserActivityState.loading = action.payload;
        },
        setActivityData: (state, action) => {
            state.UserActivityState.activityData = action.payload;
        },
        setMonthlyCounts: (state, action) => {
  state.UserActivityState.monthlyCounts = action.payload;
},
        setRealtimeData: (state, action) => {
            state.UserActivityState.realtimeData = action.payload
        },
       
        setErr: (state, action) => {
            state.UserActivityState.error = action.payload
        }


    }
});

//Fetch Top3 Spare Parts

export const FetchTopThree = () => async (dispatch: any) => {

    dispatch(Slice.actions.TopthreePartsLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/gettopthreespareparts?monthrange=6&topcnt=3`);
        dispatch(Slice.actions.TopthreeParts(res.data));
    } catch (err) {
        dispatch(Slice.actions.TopthreeError(err));
    }
}
//end

//Fetch Top 5 Parts Quoted

export const FetchAllTopFveParts = () => async (dispatch: any) => {
    dispatch(Slice.actions.GetTopFiveLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/gettopfivesparepartsquoted?monthrange=6&topcnt=5`);
        dispatch(Slice.actions.GetTopFive(res.data));
    } catch (err) {
        dispatch(Slice.actions.GetTopFiveError(err));
    }
}
//end

//Fetch Month-Wise Quote History

export const FetchAllMonthWise = () => async (dispatch: any) => {
    dispatch(Slice.actions.MonthWiseLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/monthwisequotehis?monthrange=6`);
        dispatch(Slice.actions.MonthWise(res.data));
    } catch (err) {
        dispatch(Slice.actions.MonthWiseError(err));
    }
}
//end

//Fetch Latest 5 Quote History

export const FetchAllLatestfve = () => async (dispatch: any) => {
    dispatch(Slice.actions.LatFivePartsLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/latestfivequotehis?monthrange=6&topcnt=5`);
        dispatch(Slice.actions.LatFiveParts(res.data));
    } catch (err) {
        dispatch(Slice.actions.LatFiveError(err));
    }
}
//end

//Fetch User History Data
export const FetchAllUserHisdata = () => async (dispatch: any) => {
    dispatch(Slice.actions.UserHisDataLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/userhistory?page=1&size=10`)
        dispatch(Slice.actions.UserHisData(res.data));
    } catch (err) {
        dispatch(Slice.actions.UserHisError(err));
    }
}

//Fetch Limit Users History
export const FetchUserData = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.UserHisDataLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/userhistory?page=${data}`)
        dispatch(Slice.actions.UserHisData(res.data));


    } catch (err) {
        dispatch(Slice.actions.UserHisError(err));
    }
}

// Search Results
export const SearchUserData = (data: any, page: number) => async (dispatch: any) => {
    dispatch(Slice.actions.UserHisDataLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/userhistory?email=${data}&page=${page}`)
        dispatch(Slice.actions.UserHisData(res.data));
    } catch (err) {
        dispatch(Slice.actions.UserHisError(err));
    }
}

// Search type
export const SearchInfoStatus = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.SearchInfo(data));
}


// Fetch Quote History
export const FetchAllQuoteHistory = () => async (dispatch: any) => {
    dispatch(Slice.actions.QuoteHisLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/quotehistory`);
        dispatch(Slice.actions.QuoteHisData(res.data));
    } catch (err) {
        dispatch(Slice.actions.QuoteHisError(err));
    }
}

// Fetch Quote History by Email
export const FetchQuoteHistoryByEmail = (email: any, page: number) => async (dispatch: any) => {
    dispatch(Slice.actions.QuoteHisLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/quotehistory?email=${email}&page=${page}`);
        dispatch(Slice.actions.QuoteHisData(res.data));

    } catch (err) {
        dispatch(Slice.actions.QuoteHisError(err));

    }
}
export const FetchQuoteHistoryByDate = (from_date: string, to_date: string, page: number) => async (dispatch: any) => {
    dispatch(Slice.actions.QuoteHisLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/quotehistory?from_date=${from_date}&to_date=${to_date}&page=${page}`);
        dispatch(Slice.actions.QuoteHisData(res.data));
    } catch (err) {
        console.error("Error fetching quote history by date:", err.response?.data || err.message);
        dispatch(Slice.actions.QuoteHisError(err));
    }
};
// Fetch Quote History with Pagination
export const FetchQuoteHistoryData = (page: number) => async (dispatch: any) => {
    dispatch(Slice.actions.QuoteHisLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/quotehistory?page=${page}`);
        dispatch(Slice.actions.QuoteHisData(res.data));
    } catch (err) {
        dispatch(Slice.actions.QuoteHisError(err));
    }
}
//pdf
export const downloadPdfData = (id: any) => async (dispatch: any) => {
    dispatch(Slice.actions.QuoteHisPdfLoading());
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/quotehistorypdf/${id}`);
        dispatch(Slice.actions.QuoteHisPdfData(res.data));
        dispatch(Slice.actions.showAlertMessage({
            message: PdfMessage,
            type: SuccessMessage
        }));
    } catch (error) {
        dispatch(Slice.actions.QuoteHisPdfError(error));
        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: ErrorMessage
        }));
    }
}
//Analytics
export const fetchAllEvents = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(setLoading(true));

        const res = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/events?startDate=30daysAgo&endDate=today`
        );

        dispatch(setAllEvents(res.data.data));    } catch (error: any) {
        dispatch(setError(error.response?.data));
    } finally {
        dispatch(setLoading(false));
    }
};

// Fetch specific event
export const fetchEventByName = (eventName: any) => async (dispatch: AppDispatch) => {
    try {
        dispatch(setLoading(true));
        const res = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/events/${eventName}?startDate=30daysAgo&endDate=today`
        );
        dispatch(setEventByName({ eventName, data: res.data.data }));    } catch (error: any) {
        dispatch(setError(error.response?.data));
    }
};
export const fetchUserActivity = (startDate: string, endDate: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(setLoader(true));
    const res = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/useractivityovertime?startDate=${startDate}&endDate=${endDate}`
    );

    const dailyActiveUsers = res.data?.data?.dailyActiveUsers || [];
    dispatch(setActivityData(dailyActiveUsers));

    
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthlyActiveUsers = res.data?.data?.monthlyActiveUsers || [];    const countsMap: Record<string, number> = {};

    for (const entry of monthlyActiveUsers) {
      const monthStr = entry.month.replace("-", ""); 
      const monthIndex = Number.parseInt(monthStr, 10);    
      if (!Number.isNaN(monthIndex) && monthIndex >= 1 && monthIndex <= 12) {
        const monthName = monthNames[monthIndex - 1]; 
        countsMap[monthName] = entry.activeUsers;
      }
    }

    dispatch(setMonthlyCounts(countsMap));
  } catch (error: any) {
    dispatch(setErr(error.response?.data?.message || "Error fetching userActivity"));
  } finally {
    dispatch(setLoader(false));
  }
};

export const fetchRealtimeReport = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(setLoader(true));
 
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/realtimeoverview`);
 
    const data = Array.isArray(response.data.data)
      ? response.data.data[response.data.data.length - 1]
      : response.data.data;
 
    const payload = {
      count: Number(
        data?.count ?? data?.activeUsers ?? data?.activeUsersLast30Minutes ?? 0
      ),
      timestamp: data?.timestamp ?? new Date().toISOString(),
    };
 
    dispatch(setRealtimeData(payload));
  } catch (error: any) {
    console.error("Realtime API Error:", error);
    dispatch(setError(error.message));
  } finally {
    dispatch(setLoader(false));
  }
};

// clear data
export const clearAlertMessage = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearAlertMessage());
};
export const clearQuoteDatainfo = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearQuoteHisData());
};

//Loading
export const clearLoadingUserHis = () => async (dispatch: any) => {
    dispatch(Slice.actions.UserHisDataLoading());
};

export const { UserHisData, QuoteHisData, showAlertMessage, setAllEvents, setLoading,
    setError, setEventByName, setLoader, setActivityData, setErr, setRealtimeData,setMonthlyCounts } = Slice.actions;
export const reducer = Slice.reducer;
export default Slice;
